/* eslint-disable react/require-default-props */

import React from "react";
import { Route, Routes as ReactDOMRoutes } from "react-router-dom";

import Office from "@pages/Office";
import UsersRights from "@pages/UsersRights";
import Launcher from "@pages/Launcher";
import Launch from "@pages/Launch";
import Notifications from "@pages/Notifications";

/** Pages */
import Login from "@pages/Login";
import MaintenanceUser from "@organisms/MaintenanceUser";
import ConfirmAccount from "@pages/ConfirmAccount";
import PrivateRoute from "src/routes/PrivateRoute";
import TenantSelection from "src/pages/TenantSelection";
// LEGACY MIGRATION (temporary) — remove with pages/LegacyMigration.
import LegacyMigration from "@pages/LegacyMigration";
import { ERoutes } from "src/helpers/utils";
import Sso from "src/pages/Login/sso";

const Routes: React.FC = () => (
  <ReactDOMRoutes>
    <Route path={ERoutes.home} element={<Login />} />
    <Route path={ERoutes.login} element={<Sso />} />
    <Route path={ERoutes.launch} element={<PrivateRoute component={<Launch />} />} />
    <Route path={ERoutes.confirmAccount} element={<ConfirmAccount />} />
    <Route path={ERoutes.maintenanceUser} element={<PrivateRoute component={<MaintenanceUser />} onlyAdmin />} />
    <Route path={ERoutes.identity} element={<PrivateRoute component={<Office />} />}>
      <Route index element={<Launcher />} />
      <Route
        path={ERoutes.selectTenant}
        element={
          <PrivateRoute component={<TenantSelection />} redirectTo={`/${ERoutes.identity}/${ERoutes.users}`} onlyAdmin />
        }
      />
      {/* LEGACY MIGRATION (temporary) */}
      <Route
        path={ERoutes.legacyMigration}
        element={<PrivateRoute component={<LegacyMigration />} onlyAdmin />}
      />
      <Route path={ERoutes.users} element={<UsersRights />} />
      <Route
        path={ERoutes.notifications}
        element={<PrivateRoute component={<Notifications />} redirectTo={`/${ERoutes.identity}`} onlyAdmin />}
      />
    </Route>
  </ReactDOMRoutes>
);

export default Routes;
